




















import {Component, Mixins, Prop } from 'vue-property-decorator';
import { CommitteeModel } from '@api/models/committees/CommitteeModel';
import { SessionTypeEnum } from '@api/enums/Session/SessionTypeEnum';

import RoundButtonKebab from "@share/common/buttons/RoundButtonKebab.vue";
import RoundButtonEdit from "@share/common/buttons/RoundButtonEdit.vue";
import KebabMenu from "@share/common/kebab-menu/KebabMenu.vue";
import TimeCardTopBase from '@share/common/cards/time-card/components/top/TimeCardTopBase.vue';
import { MenuEvent } from '@api/enums/MenuEvents';
import Deletable from '@share/common/base/deletable/Deletable.vue';

@Component({ components: { RoundButtonKebab, RoundButtonEdit, KebabMenu }})
export default class CommitteeCardTop extends Mixins(TimeCardTopBase, Deletable) {

    @Prop({ required: true }) declare source: CommitteeModel;
    @Prop() isAdmin: boolean;

    async chooseHandler(eventName: MenuEvent) {
        if (eventName === MenuEvent.delete) {
            await this.delete(this.$t('committees.deleteCommitteeConfirmTitle').toString())
        }
    }

    get sourceType(): SessionTypeEnum {
        return this.source.type;
    }

    get isOnEditing() {
        return this.$store.state.isOnEditing;
    }
}

